module.exports = __webpack_public_path__ + "img/tres.5e3bdd4f.png";